import { z, ZodTypeAny } from 'zod';
import { getDefaultData } from '@brickwise/asset-validation/dist/utils';
import { merge } from 'lodash';

export const getInitFormValues = <T extends ZodTypeAny>(schema: T, data: unknown): z.infer<typeof schema> => {
  const parseResult = schema.safeParse(data);

  const initialData = parseResult.success ? parseResult.data : data;

  return merge(getDefaultData(schema), initialData);
};
